import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'

export function buildItemBookingChangedActivityEntry(title: string, isBooked: boolean, occurredAt: string): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'item_status_changed',
    label: 'Updated itinerary booking',
    displayText: boundActivityDisplayText(isBooked ? `Marked "${title}" as booked` : `Cleared manual booking for "${title}"`),
    sourcePath: 'trip_planner.list.booking_update',
    dataClassification: 'personalised_surface',
    occurredAt,
  }
}
